import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CUSTOM_PLAN_ID } from '../components/quoting/planSection/constants';
import { useCalculatePlanPrice } from './useCalculatePlanPrice';
import {
  saveDeductibleSelected,
  saveSelectedReimbursement,
  selectedPlan,
} from '../actions';

export const usePrepackagedPlans = () => {
  const dispatch = useDispatch();
  const { quoteSelected, plansPackaged } = useCalculatePlanPrice();

  const isCustomPlanSelected = quoteSelected.selectedPlanPackaged
    === CUSTOM_PLAN_ID;

  const onChangePrepackagedPlan = useCallback((plan) => ({
    planId,
    planAmount,
    planPackagedId,
  }) => {
    dispatch(selectedPlan({ planAmount, planId, planPackagedId }));
    dispatch(saveSelectedReimbursement({
      description: plan.reimbursementName,
      id: plan.ReimbursementId,
    }));
    dispatch(saveDeductibleSelected({
      description: plan.deductibleName,
      id: plan.DeductibleId,
    }));
  }, [dispatch]);

  const onChangeCustomPlan = useCallback(({
    planAmount,
    planId,
    planPackagedId,
  }) => {
    dispatch(selectedPlan({ planAmount, planId, planPackagedId }));
  }, [dispatch]);

  return {
    isCustomPlanSelected,
    onChangeCustomPlan,
    onChangePrepackagedPlan,
    plansPackaged,
    quoteSelected,
  };
};
